export default "__VITE_ASSET__DzUkCVDI__"